import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CompanyService } from '../shared/company.service';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent implements OnInit {
  datatable:any;
  constructor(private chRef:ChangeDetectorRef,
              public companyService: CompanyService) { }

  ngOnInit() {
    this.companyService.refreshList().then(
      r=>{
        this.initDatatable();
      }
    );
  }

 private initDatatable(): void {
    if ($.fn.dataTable.isDataTable('#dataTableCompany')) {
      this.datatable.destroy();
    }
    this.chRef.detectChanges();
    const table: any = $('#dataTableCompany');
    this.datatable = table.DataTable({
      responsive: true
    });
  } 

}
